<mat-form-field [className]="props.style" [appearance]="props.appearance">
  <mat-label>{{ props?.label }} {{ props.required ? '*' : '' }}</mat-label>
  <mat-select [formControl]="selectFormControl" [formlyAttributes]="field">
    <mat-option *ngFor="let value of values" [value]="value">{{ value.label }}</mat-option>
  </mat-select>
  <mat-error *ngIf="selectFormControl.errors?.['required']">{{ field.validation?.messages?.['required'] }}</mat-error>
</mat-form-field>
